module.exports = __webpack_public_path__ + "static/media/10.6e7b5bf0.jpg";